import React, { useState } from 'react';
import {
	morePipelineFiltersBuyer,
	morePipelineFiltersSupplier,
	pipelineFiltersBuyer,
	pipelineFiltersSupplier,
} from '../config/pipelineFilters/pipelineFilters';
import { PipelineFilter } from '../pipelineFilters/pipelineFilters';
import { Button, Col, Row } from 'antd';
import RightActions from './RightActions';
import Filters from '../filters/filters';
import { ROLE_TYPES, VIEW_ENTITY_TYPES } from '../../../utils/DataConstants';
import AssignedFilters from '../AssignedFilters';
import { nullSafeGet, nullSafeGetOrElse } from '../../../utils/DataAccessUtils';
import SelectedFilters from '../../selected_filters_pills/SelectedFilters';
import SaveFiltersActions from '../../saved_filter_views/SaveFiltersActions';
import { getBuyerCompanySettingValue, isInternalTech } from '../../../utils/AuthUtils';
import SubContractedFilters from '../SubContractedFilters';

export default function TableHeader({
	sorters,
	filterConfig,
	applySorting,
	applyFilters,
	filters,
	currentUser,
	switchDisplayMode,
	isDisplayModeActive,
	downloadCSV,
	counts,
	clearFilters,
	targetCollectionName,
	preAppliedFilters,
	applyFiltersFromView,
	userType,
	companyConfig,
	refreshTable,
	location,
}) {
	const filterConfiguration = filterConfig || {};
	const showDeferred = getBuyerCompanySettingValue(userType)(
		'workOrder.allowWorkOrderToBeDeferred',
		companyConfig,
		currentUser,
		false
	);
	return (
		<div style={{ margin: '16px 8px', display: 'grid', rowGap: '12px' }}>
			<PipelineFilter
				items={
					userType === ROLE_TYPES.SUPPLIER
						? pipelineFiltersSupplier(showDeferred)
						: pipelineFiltersBuyer(showDeferred)
				}
				subItems={
					userType === ROLE_TYPES.SUPPLIER
						? morePipelineFiltersSupplier(showDeferred, isInternalTech(currentUser))
						: morePipelineFiltersBuyer(showDeferred)
				}
				onChange={applyFilters}
				mode="multiple"
				value={filters}
				counts={counts}
				targetCollectionName={targetCollectionName}
				{...filterConfiguration.pipelineFilters}
			/>
			<Row justify="space-between">
				<Col xl={18} xxl={16} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
					<Filters
						filterConfig={filterConfiguration.filters}
						currentUser={currentUser}
						applyFilters={applyFilters}
						applySorting={applySorting}
						filters={filters}
						clearFilters={clearFilters}
						targetCollectionName={targetCollectionName}
						userType={userType}
						sorters={sorters}
						preAppliedFilters={preAppliedFilters}
					/>
					<SaveFiltersActions
						preAppliedFilters={preAppliedFilters}
						activeFIlters={filters}
						activeSorter={sorters}
						userType={userType}
						entityType={VIEW_ENTITY_TYPES.WORKORDERS}
						applyFiltersFromView={applyFiltersFromView}
					/>
				</Col>
				<Col
					xl={6}
					xxl={8}
					style={{
						textAlign: 'right',
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'flex-end',
						gap: '8px',
					}}
				>
					<RightActions
						downloadCSV={downloadCSV}
						switchDisplayMode={switchDisplayMode}
						isDisplayModeActive={isDisplayModeActive}
						currentUser={currentUser}
						userType={userType}
						filters={filters}
						counts={counts}
						refreshTable={refreshTable}
						applyFilters={applyFilters}
						location={location}
					/>
				</Col>
			</Row>

			{userType === ROLE_TYPES.SUPPLIER ? (
				<div className="flex flex-row items-center gap-4 ">
					<AssignedFilters
						items={nullSafeGetOrElse('assignedFilters.items', filterConfiguration, [])}
						currentUser={currentUser}
						userType={userType}
						value={filters}
						onChange={applyFilters}
						selector={nullSafeGetOrElse('assignedFilters.selector', filterConfiguration, '')}
					/>

					<SubContractedFilters
						items={nullSafeGetOrElse('subContractedFilters.items', filterConfiguration, [])}
						currentUser={currentUser}
						userType={userType}
						value={filters}
						onChange={applyFilters}
						selector={nullSafeGetOrElse('subContractedFilters.selector', filterConfiguration, '')}
					/>
				</div>
			) : null}

			<SelectedFilters
				updateFilters={applyFilters}
				filterValues={filters}
				filterConfig={filterConfiguration.filters}
			/>
		</div>
	);
}
